module.exports = __webpack_public_path__ + "static/media/zip.415857c2.svg";